import { Component, Input } from '@angular/core';
import { TaskService, JobsService } from 'src/app/modules/instance/services';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-restart-process-button',
    templateUrl: './restart-process-button.component.html',
    styleUrls: ['../styles/common-process-action-button.scss']
})
export class RestartProcessButtonComponent {
    constructor(
        private readonly dialog: MatDialog,
        private readonly taskService: TaskService,
        private readonly jobsService: JobsService
    ) { }

    ngOnInit(): void {
    }

    @Input()
    public label: string;

    @Input()
    public process: ITaskModel;

    public restartProcess(_event: Event) {
        if (!this.process.canRestart) {
            this.openActionNotAllowedDialog();
            return;
        }

        let method = !!this.taskService.getProcessById(this.process.id)
            ? this.taskService.checkTaskStatus.bind(this.taskService)
            : !!this.jobsService.getProcessById(this.process.id)
                ? this.jobsService.checkJobStatus.bind(this.jobsService)
                : null;


        if (method) {
            this.jobsService
                .restartProcess(this.process, true)
                .subscribe(() => {
                    method(this.process);
                })
        }
        else {
            console.log(`RestartProcessButtonComponent.restartProcess => can not restart process. Not found in Tasks and Jobs service`);
        }
    }

    private openActionNotAllowedDialog() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            title: 'Start recalculation',
            topContent: 'The process is in progress.',
            bottomContent: 'Please stop it before restart',
            okButtonColor: 'warn',
            hideYesButton: true,
            hideNoButton: true,
            showCancelButton: true
        };

        const dialog = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        dialog
            .afterClosed()
            .pipe(
                filter(isConfirm => isConfirm)
            )
            .subscribe(() => { });
    }

}
